import { createFileRoute, useParams } from '@tanstack/react-router';
import { DiagTests } from '@amber-ui/core';

function DevicesFanController() {
  const { core_id } = useParams({ from: '/devices/fc/$core_id' });
  return <DiagTests routeParams={{ core_id }} />;
}

export const Route = createFileRoute('/devices/fc/$core_id')({
  component: DevicesFanController,
});
